<template>
  <vxe-table
    ref="table"
    :key="tableKey"
    :data="dataList"
    :border="border"
    :height="height"
    show-overflow="title"
    show-header-overflow="title"
    class="draggable-widget"
    :keep-source="this.rowEdit"
    :row-config="{ height: rowHeight }"
    :column-config="{ resizable: true }"
    :edit-config="{
      trigger: 'manual',
      mode: 'row',
      enabled: this.rowEdit,
      showIcon: false,
      autoClear: false,
      showStatus: true,
    }"
    :edit-closed="onSaveRowData"
    :seq-config="{ seqMethod }"
    @sort-change="onSortChange"
    @checkbox-change="onCheckBoxChange"
    @checkbox-all="onCheckBoxChange"
    @radio-change="onRadioSelectChange"
    :sort-config="{ remote: remoteSort }"
  >
    <vxe-column
      v-if="hasBatchOperation && !form().readOnly"
      type="checkbox"
      :width="60"
    />
    <vxe-column v-if="singleSelect" type="radio" align="center" :width="50" />
    <vxe-column v-if="tableColumnList.length > 0" type="seq" title="序号" :width="50" />
    <template v-for="tableColumn in tableColumnList">
      <!-- Boolean类型字段 -->
      <vxe-column
        v-if="tableColumn.column && tableColumn.column.objectFieldType === 'Boolean'"
        :key="tableColumn.columnId"
        :title="tableColumn.showName"
        :width="tableColumn.columnWidth"
      >
        <template #default="{ row }">
          <el-tag
            :size="defaultFormItemSize"
            :type="row[tableColumn.showFieldName] ? 'success' : 'danger'"
          >
            {{ row[tableColumn.showFieldName] ? "是" : "否" }}
          </el-tag>
        </template>
      </vxe-column>
      <!-- 图片类型字段 -->
      <vxe-column
        v-else-if="
          tableColumn.column &&
          tableColumn.column.fieldKind === SysOnlineFieldKind.UPLOAD_IMAGE
        "
        :key="tableColumn.columnId"
        :title="tableColumn.showName"
        :width="tableColumn.columnWidth"
      >
        <template #default="{ row }">
          <el-image
            v-for="item in parseTableUploadData(tableColumn, row)"
            :preview-src-list="getTablePictureList(tableColumn, row)"
            class="table-cell-image"
            :key="item.url"
            :src="item.url"
            fit="fill"
          >
            <div slot="error" class="table-cell-image">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </vxe-column>
      <!-- 文件下载类型字段 -->
      <vxe-column
        v-else-if="
          tableColumn.column && tableColumn.column.fieldKind === SysOnlineFieldKind.UPLOAD
        "
        :key="tableColumn.columnId"
        :title="tableColumn.showName"
        :width="tableColumn.columnWidth"
      >
        <template #default="{ row }">
          <a
            v-for="item in parseTableUploadData(tableColumn, row)"
            :key="item.url"
            href="javascript:void(0);"
            @click="downloadFile(item.url, item.name)"
          >
            {{ item.name }}
          </a>
        </template>
      </vxe-column>
      <!-- 其他类型 -->
      <vxe-column
        v-else
        :key="tableColumn.columnId"
        :title="tableColumn.showName"
        :field="tableColumn.showFieldName"
        :width="tableColumn.columnWidth"
        :sortable="tableColumn.sortable"
      />
    </template>
    <vxe-column
      title="操作"
      :width="widget.props.operationColumnWidth || 160"
      fixed="right"
      :show-overflow="false"
      v-if="(rowEdit || tableOperationList.length > 0) && tableColumnList.length > 0"
    >
      <template #default="{ row }">
        <el-button
          v-for="operation in tableOperationList"
          :key="operation.id"
          v-show="form().checkOperationVisible(operation, row)"
          :size="defaultFormItemSize"
          type="text"
          :class="operation.btnClass"
          :plain="operation.plain"
          :disabled="
            !form().checkOperationPermCode(operation) ||
            form().checkOperationDisabled(operation, row)
          "
          @click="onOperationClick(operation, row)"
        >
          {{ operation.name }}
        </el-button>
        <!--
        <template v-if="$refs.table.isEditByRow(row)">
          <el-button class="table-btn success" size="mini" type="text" @click="saveRowEvent(row)">保存</el-button>
          <el-button size="mini" type="text" @click="cancelRowEvent(row)">取消</el-button>
        </template>
        <template v-else>
          <el-button class="table-btn success" size="mini" type="text" :disabled="editInfo.editRow != null && editInfo.editRow !== row" @click="editRowEvent(row)">编辑</el-button>
          <el-button class="table-btn delete" size="mini" type="text" :disabled="editInfo.editRow != null && editInfo.editRow !== row" @click="deleteRowEvent(row)">删除</el-button>
        </template>
        -->
      </template>
    </vxe-column>
  </vxe-table>
</template>

<script>
import { findItemFromList } from "@/utils";
import { uploadMixin } from "@/core/mixins";

export default {
  name: "OnlineCustomTable",
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    height: {
      type: [String, Number],
      default: "auto",
    },
    border: {
      type: String,
      default: "full",
    },
    // 是否支持行内编辑
    rowEdit: {
      type: Boolean,
      default: false,
    },
    // 是否支持多选
    multiSelect: {
      type: Boolean,
      default: false,
    },
    // 是否支持单选
    singleSelect: {
      type: Boolean,
      default: false,
    },
    // 表格操作列表
    operationList: {
      type: Array,
      default: () => [],
    },
    widget: {
      type: Object,
    },
    // 获取行序号
    getTableIndex: {
      type: Function,
    },
    // 排序改变
    sortChange: {
      type: Function,
    },
    // 多选选中改变
    onSelectChange: {
      type: Function,
    },
    // 单选中改变
    onRadioChange: {
      type: Function,
    },
  },
  inject: ["form"],
  mixins: [uploadMixin],
  data() {
    return {
      editInfo: {
        editRow: undefined,
      },
      sortInfo: undefined,
    };
  },
  methods: {
    seqMethod(data) {
      if (this.getTableIndex) {
        return this.getTableIndex(data.seq - 1);
      } else {
        return data.seq;
      }
    },
    onSortChange(data) {
      if (!this.widget.props.paged) return;
      let fieldName = data.property.replace("DictMap.name", "");
      let order = data.order;
      if (order == null) {
        fieldName = undefined;
      }
      if (order === "asc") order = "ascending";
      if (
        this.sortInfo != null &&
        this.sortInfo.prop === fieldName &&
        this.sortInfo.order === order
      ) {
        return;
      }
      this.sortInfo = {
        prop: fieldName,
        order: order,
      };
      if (this.sortChange) {
        this.sortChange(this.sortInfo);
      }
    },
    onCheckBoxChange() {
      if (this.$refs.table && typeof this.onSelectChange === "function") {
        let selectRows = this.$refs.table.getCheckboxRecords(true);
        this.onSelectChange(selectRows);
      }
    },
    onRadioSelectChange() {
      if (this.$refs.table && typeof this.onRadioChange === "function") {
        let selectRow = this.$refs.table.getRadioRecord();
        this.onRadioChange(selectRow);
      }
    },
    setSelectedRow(rowNum) {
      this.$refs.table.setRadioRow(this.dataList[rowNum]);
    },
    // 取消行内编辑
    cancelRowEvent(row) {
      if (this.form().isEdit) return;
      this.$refs.table
        .clearActived()
        .then(() => {
          // 还原行数据
          this.$refs.table.revertData(row);
          this.editInfo.editRow = undefined;
        })
        .catch((e) => {});
    },
    // 启动行内编辑
    editRowEvent(row) {
      if (this.form().isEdit) return;
      this.$refs.table.setEditRow(row);
      this.editInfo.editRow = row;
    },
    // 保存行内编辑数据
    saveRowEvent(row) {
      if (this.form().isEdit) return;
      this.$refs.table.clearActived().then(() => {
        this.$refs.table.reloadRow(row);
        this.editInfo.editRow = undefined;
      });
    },
    onSaveRowData({ row }) {},
    // 新建行内编辑数据
    addRowEvent(row) {
      if (this.form().isEdit) return;
      this.$refs.table.insertAt(row, 0).then((res) => {
        let newRow = res.row;
        this.$refs.table.setEditRow(newRow);
      });
    },
    // 删除行数据
    deleteRowEvent(row) {
      if (this.form().isEdit) return;
      this.$emit("delete", row);
    },
    onOperationClick(operation, row) {
      this.$emit("operationClick", operation, row);
    },
    refreshColumn() {
      this.$nextTick(() => {
        if (this.$refs.table) this.$refs.table.refreshColumn();
      });
    },
    getDownloadUrl(tableColumn) {
      let downloadUrl = null;
      if (this.form().flowData != null) {
        downloadUrl = "/admin/flow/flowOnlineOperation/download";
      } else {
        if (tableColumn.relationId) {
          downloadUrl =
            "/admin/online/onlineOperation/downloadOneToManyRelation/" +
            (this.widget.datasource || {}).variableName;
        } else {
          downloadUrl =
            "/admin/online/onlineOperation/downloadDatasource/" +
            (this.widget.datasource || {}).variableName;
        }
      }

      return downloadUrl;
    },
    parseTableUploadData(tableColumn, row) {
      let jsonData = row[tableColumn.showFieldName];
      if (jsonData == null) return [];
      let downloadParams = {
        ...this.buildFlowParam,
        datasourceId: this.widget.datasource.datasourceId,
        relationId: tableColumn.relationId,
        fieldName: tableColumn.column.columnName,
        asImage: tableColumn.column.fieldKind === this.SysOnlineFieldKind.UPLOAD_IMAGE,
      };

      if (this.widget.primaryColumnName != null) {
        downloadParams.dataId = row[this.widget.primaryColumnName] || "";
      }

      let downloadUrl = this.getDownloadUrl(tableColumn);

      let temp = JSON.parse(jsonData);
      temp = Array.isArray(temp)
        ? temp.map((item) => {
            return {
              ...item,
              downloadUri: downloadUrl,
            };
          })
        : [];
      return this.parseUploadData(JSON.stringify(temp), downloadParams);
    },
    getTablePictureList(tableColumn, row) {
      let temp = this.parseTableUploadData(tableColumn, row);
      if (Array.isArray(temp)) {
        return temp.map((item) => item.url);
      }
    },
    formatListData(data) {
      Object.keys(data).forEach((key) => {
        let subData = data[key];
        if (typeof subData === "object" && key.indexOf("DictMap") === -1) {
          this.formatListData(subData);
        } else {
          // 如果是多选字典字段，那么把选中的字典值拼接成DictMap去显示
          if (key.indexOf("DictMapList") !== -1 && Array.isArray(data[key])) {
            let newKey = key.replace("DictMapList", "DictMap");
            data[newKey] = {
              id: data[key.replace("DictMapList", "")],
              name: data[key].map((subItem) => subItem.name).join(","),
            };
          }
        }
      });
    },
  },
  computed: {
    buildFlowParam() {
      let flowParam = {};
      let flowData = this.form().flowData;
      if (flowData) {
        if (flowData.processDefinitionKey)
          flowParam.processDefinitionKey = flowData.processDefinitionKey;
        if (flowData.processInstanceId)
          flowParam.processInstanceId = flowData.processInstanceId;
        if (flowData.taskId) flowParam.taskId = flowData.taskId;
      }

      return flowParam;
    },
    tableColumnList() {
      let tempList =
        this.widget &&
        this.widget.props &&
        Array.isArray(this.widget.props.tableColumnList)
          ? this.widget.props.tableColumnList
          : [];
      tempList.forEach((item) => {
        if (item.fieldType === 0 || item.fieldType == null) {
          // 绑定表字段
          if (item.column) item.showFieldName = item.column.columnName;
          if (this.widget.relation == null && item.relation != null) {
            item.showFieldName = item.relation.variableName + "." + item.showFieldName;
          }
          if (item.column && item.column.dictInfo) {
            item.showFieldName = item.showFieldName + "DictMap.name";
          }
        } else {
          // 自定义字段
          item.showFieldName = item.customFieldName;
        }
      });
      return tempList;
    },
    tableOperationList() {
      return this.operationList.filter((item) => {
        let temp = item.enabled && item.rowOperation;
        if (temp && this.form().readOnly) {
          temp = temp && item.readOnly;
        }
        return temp;
      });
    },
    hasBatchOperation() {
      let batchDeleteOperation = findItemFromList(
        this.operationList,
        this.SysCustomWidgetOperationType.BATCH_DELETE,
        "type"
      );
      let printOperation = findItemFromList(
        this.operationList,
        this.SysCustomWidgetOperationType.PRINT,
        "type"
      );
      return (
        (batchDeleteOperation != null && batchDeleteOperation.enabled) ||
        (printOperation != null && printOperation.enabled && !printOperation.rowOperation)
      );
    },
    hasImageColumn() {
      return (
        this.tableColumnList.filter((tableColumn) => {
          return (
            tableColumn.column &&
            tableColumn.column.fieldKind === this.SysOnlineFieldKind.UPLOAD_IMAGE
          );
        }).length > 0
      );
    },
    rowHeight() {
      return this.hasImageColumn ? 80 : 35;
    },
    tableKey() {
      return (
        (this.widget || {}).variableName +
        new Date().getTime() +
        this.tableColumnList.length
      );
    },
    remoteSort() {
      return this.widge ? (this.widget.props || {}).paged : false;
    },
  },
  watch: {
    dataList: {
      handler() {
        if (Array.isArray(this.dataList)) {
          this.dataList.forEach((item) => {
            this.formatListData(item);
          });
        }
      },
      immediate: true,
    },
    tableColumnList: {
      handler() {
        this.refreshColumn();
      },
      immediate: true,
    },
    "widget.props.operationColumnWidth": {
      handler() {
        this.refreshColumn();
      },
    },
  },
};
</script>

<style></style>
